/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const RETRY_CALCULATE_SHIPPING_ATTEMPT = 'RETRY_CALCULATE_SHIPPING_ATTEMPT';
export const CLEAR_CALCULATE_SHIPPING_ATTEMPT = 'CLEAR_CALCULATE_SHIPPING_ATTEMPT';
export const UPDATE_CALCULATE_SHIPPING_APPLIED = 'UPDATE_CALCULATE_SHIPPING_APPLIED';
